<template>
  <div class="home-trans-list">
    <action-bar>
      <search placeholder="请输入交易ID" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <el-date-picker
        v-model="searchCriteria.f_like_id"
        type="daterange"
        range-separator="⇀"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <normal-table
        :table-data="tableData"
        :table-col="tableCol"
        :paging="paging"
        :show-edit="showEdit"
        :operator="operator"
        :operate-col="operatorCol"
        @pagination="getTxnListFn"
      >
      <template slot="txId" slot-scope="{ param }">
        <div class="tx-id">{{ param.row.txId || $constants.EMPTY}}</div>
      </template>
      <template slot="originUser" slot-scope="{ param }">
        <div class="origin-user">{{ param.row.sender || $constants.EMPTY }}</div>
      </template>
    </normal-table>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'List',
  components: {
    subscribeBlock
  },
  data() {
    return {
      showEdit: true,
      operator: [
        {
          text: '查看',
          showText: true,
          icon: 'icon-check',
          class: 'operate-check',
          click: row => {
            return this.goDetail(row)
          }
        }
      ],
      operatorCol: {
        minWidth: 74
      },
      searchCriteria: {
        f_like_id: '',
        f_like_name: ''
      },
      tableCol: [
        {
          label: '交易id',
          prop: 'txId',
          minWidth: 313,
          slotName: 'txId',
          // path: row => {
          //   return {
          //     name: 'txnDetail',
          //     query: {
          //       txId: row.txId
          //     }
          //   }
          // },
        },
        {
          label: '区块高度',
          prop: 'blockHeight',
          minWidth: 116
        },
        {
          label: '发起组织',
          prop: 'orgId',
          minWidth: 116
        },
        {
          label: '目标合约',
          prop: 'contractName',
          minWidth: 116
        },
        {
          label: '上链时间',
          prop: 'timestamp',
          minWidth: 116
        },
        {
          label: '发起用户',
          prop: 'sender',
          minWidth: 132,
          slotName: 'originUser',
        },
        {
          label: '交易状态',
          prop: 'txStatusCode',
          minWidth: 218
        }
      ]
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.home.txn_list,
      paging: state => state.home.txn_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getTxnListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getTxnListFn()
    }
  },
  methods: {
    ...mapActions(['getTxnLists']),
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    },
    onSearch(val) {
      function ISODateString(d) {
        function pad(n) {
          return n < 10 ? '0' + n : n
        }
        return (
          d.getUTCFullYear() +
          '-' +
          pad(d.getUTCMonth() + 1) +
          '-' +
          pad(d.getUTCDate()) +
          'T' +
          pad(d.getUTCHours()) +
          ':' +
          pad(d.getUTCMinutes()) +
          ':' +
          pad(d.getUTCSeconds()) +
          'Z'
        )
      }

      let startTime =
        (this.searchCriteria.f_like_id && new Date(this.searchCriteria.f_like_id[0])) || null
      let endTime =
        (this.searchCriteria.f_like_id && new Date(this.searchCriteria.f_like_id[1])) || null

      startTime && (startTime = ISODateString(startTime))
      endTime && (endTime = ISODateString(endTime))

      this.getTxnListFn({
        offset: 0,
        limit: 10,
        txId: val,
        startTime: startTime,
        endTime: endTime
      })
    },
    getTxnListFn(params = {}) {
      params.offset = params.offset * this.paging.limit || 0
      params.limit = params.limit || 10
      params.chainId = this.$store.state.home.chainCid

      this.getTxnLists(params)
    },
    goDetail(row) {
      this.$router.push({
        name: 'txnDetail',
        query: {
          txId: row.txId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-trans-list',
  (
    --home-trans-list-operate-check-color: #45c2ff,
    --date-seletor-border-color: rgba(69, 194, 255, 0.5)
  ),
  (
    --home-trans-list-operate-check-color: #45c2ff,
    --date-seletor-border-color: #ebebeb
  )
);
.home-trans-list {
  @include adaptation(
    (
      --home-trans-list-search-width: 253px,
      --home-trans-list-offset: 48px,
      --home-trans-list-item-height: 64px,
      --home-trans-date-picker-margin-right: 24px,
      --home-trans-date-picker-height: 32px,
      --home-trans-date-picker-padding: 1px 10px,
      --home-trans-date-picker-width: 265px,
    )
  );
  --home-trans-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-trans-list-offset)
  );

  .cbaas-search-wrap {
    width: var(--home-trans-list-search-width);
  }

  .el-date-editor.el-date-editor--daterange {
    margin-right: var(--home-trans-date-picker-margin-right);
    padding: var(--home-trans-date-picker-padding);
    height: var(--home-trans-date-picker-height);
    width: var(--home-trans-date-picker-width);
    border-color: var(--date-seletor-border-color);
  }

  .common-bg-plate {
    .normal-table-wrap {
      height: 100%;
      min-height: var(--home-trans-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-trans-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--home-trans-list-min-height);

          .el-table {
            .el-table__body {
              tr {
                height: var(--home-trans-list-item-height);

                .el-table__cell {
                  .cell {
                    height: auto;
                    white-space: normal;
                  }
                }
              }
            }
          }

          .tx-id, .origin-user {
            padding-right: var(--base-size-64);
          }

          .operate-item.operate-check {
            color: var(--home-trans-list-operate-check-color);
          }
        }
      }
    }
  }
}
</style>
